import { Button, DialogContent } from '@mui/material';
import * as React from 'react';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { Sidebar } from '~/components/Sidebar';
import { SidebarMenu } from '~/components/Sidebar/SidebarMenu';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useDialogState } from '~/hooks/useDialogState';
import { RedirectToPortalHomepage } from '~/scenes/PortalViews/components/RedirectToPortalHomepage';
import { SidebarLayout } from '~/scenes/PortalViews/components/SidebarLayout';
import { StructuredModuleRouter } from '~/scenes/PortalViews/components/StructuredModuleRouter';
import { useAdminViews } from '~/scenes/PortalViews/Views/AdminViews/useAdminViews';

export const AdminViews = () => {
  const { userHasAccess, navigationPaths, routingStructure } = useAdminViews();

  const { isOpen, open, close } = useDialogState();

  if (!userHasAccess) {
    // TODO Redirect to Access denied page once we have one
    return <RedirectToPortalHomepage />;
  }

  return (
    <SidebarLayout
      sidebar={
        <Sidebar>
          <SidebarMenu
            navigationRootPath={'/portal/admin'}
            levelPaths={navigationPaths}
          />
          <Button onClick={open}>Test button</Button>
          <DraggableDialog open={isOpen}>
            <SolaForceDialogTitle onClose={close}>Lorem</SolaForceDialogTitle>
            <DialogContent>Ipsum dolor sit amet</DialogContent>
          </DraggableDialog>
        </Sidebar>
      }
    >
      <PortalErrorBoundary>
        <StructuredModuleRouter routingStructure={routingStructure} />
      </PortalErrorBoundary>
    </SidebarLayout>
  );
};
